"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsagePricingSchemaProperties = exports.UsagePricingSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.UsagePricingSchema = base_schema_1.BaseSchema.extend({
    amount: zod_1.z.number(),
    currency: zod_1.z.string(),
    taxTypeId: zod_1.z.string(),
    createdBy: zod_1.z.string(),
    clientId: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    packageInstanceId: zod_1.z.string(),
    schedulerId: zod_1.z.string(),
});
exports.UsagePricingSchemaProperties = {
    collectionName: "usagePricing",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=usage-pricing-schema.js.map